/**
 * src/lib/voice/voicePacketBuilder.js — Phase 76-02 Task 3
 *
 * Pure helper that resolves the current AppDataContext snapshot into the
 * base voice knowledge packet. Lifted out of useVoiceConversation.
 */

import { buildBasePacket } from './knowledgePacket';

export function buildVoicePacket({ app, contextProjectId, contextDealId, conversationHistory }) {
  const activeProject = contextProjectId
    ? (app?.projects || []).find(p => p.id === contextProjectId) || null
    : null;
  const activeDeal = contextDealId
    ? (app?.crm || []).find(d => d.id === contextDealId) || null
    : null;
  const activeVessel = activeProject?.vessel_id
    ? (app?.vessels || []).find(v => v.id === activeProject.vessel_id) || null
    : null;
  const recentTasks = activeProject
    ? (app?.tasks || [])
        .filter(t => t.project_id === activeProject.id && !t.archived_at)
        .sort((a, b) => String(b.updated_at || '').localeCompare(String(a.updated_at || '')))
        .slice(0, 5)
    : [];
  const userLanguage = (typeof localStorage !== 'undefined' && localStorage.getItem('acn_lang')) || 'en';

  return buildBasePacket({
    activeProject, activeDeal, activeVessel, recentTasks,
    conversationHistory,
    userLanguage,
    responseMode: 'voice_short_text_full',
  });
}
